module.exports = __webpack_public_path__ + "static/img/mei.f162dd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/mei.jpg
// module id = TeVF
// module chunks = 0